import { useMutation, useQuery } from "@tanstack/react-query";
import {
  SettingCatalogService,
  SettingCatalogSearchPayload,
} from "../services/settingCatalog.service";
import { SettingPayload } from "../domain/settingCatalog.interface";

export const useSettingsCatalog = (filters: SettingCatalogSearchPayload) => {
  const {
    data: settings,
    isLoading: isLoadingSettings,
    isFetching: isFetchingSettings,
    refetch: refetchSettings,
  } = useQuery({
    queryKey: ["parca-settings-catalog-search"],
    queryFn: () => SettingCatalogService.search(filters),
  });

  return {
    settings,
    isLoadingSettings,
    isFetchingSettings,
    refetchSettings,
  };
};

// Bare list of definitions, used to drive the per-account values screen.
export const useSettingsCatalogList = (
  application?: string,
  enabled = true
) => {
  const {
    data: settingsList,
    isLoading: isLoadingSettingsList,
    isFetching: isFetchingSettingsList,
    refetch: refetchSettingsList,
  } = useQuery({
    queryKey: ["parca-settings-catalog-list", application ?? "all"],
    queryFn: () => SettingCatalogService.findAll(application),
    enabled,
  });

  return {
    settingsList,
    isLoadingSettingsList,
    isFetchingSettingsList,
    refetchSettingsList,
  };
};

export const useCreateSetting = () => {
  return useMutation({
    mutationFn: (payload: SettingPayload) =>
      SettingCatalogService.createOne(payload),
  });
};

export const useUpdateSetting = () => {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: Partial<SettingPayload>;
    }) => SettingCatalogService.updateOne({ id, payload }),
  });
};

export const useArchiveSetting = () => {
  return useMutation({
    mutationFn: (id: string) => SettingCatalogService.archiveOne(id),
  });
};
